import _extends from "@babel/runtime/helpers/esm/extends";
import React, { forwardRef, memo } from 'react';
import { StyledBox } from './styled';
const RawBox = props => /*#__PURE__*/React.createElement(StyledBox, _extends({
  ref: props.forwardedRef
}, props));
export const Box = /*#__PURE__*/memo( /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/React.createElement(RawBox, _extends({}, props, {
  forwardedRef: ref
}))));
Box.displayName = 'Box';